import Api from './api.service'

import Configuration from '@/configuration'
const baseURL = Configuration.value('apiFrontend')
const backendBaseURL = Configuration.value('apiBackend')

export default {
  getList(params) {
    if (Configuration.value('client') === 'fleetpool' && !params.opendamagesMin) {
      params.opendamagesMax = 1999
    }
    return Api().get(`${baseURL}/vehicle`, { params })
  },
  get(id) {
    return Api().get(`${baseURL}/vehicle/${id}`)
  },
  getLatest() {
    return Api().get(`${baseURL}/vehicle/latest`)
  },
  getMakes(params) {
    return Api().get(`${baseURL}/vehicle/makes`, { params: params })
  },
  getFilters(params) {
    return Api().get(`${baseURL}/vehicle/filters`, { params: params })
  },
  createOffer(payload) {
    return Api().post(`${baseURL}/offer`, payload)
  },
  getListForPackages(packageId, page, params) {
    return Api().get(`${baseURL}/vehicle/package-list/${packageId}`, { params: { page: page, ...params } })
  },
  getCartHistory(carId) {
    return Api().get(`${backendBaseURL}/cart-history/${carId}`)
  }
}
